// utils/referral.js — the personal referral code (?i=<code>) captured from
// an invite link or the standalone /i/<code> landing, carried across the
// redirect to /register the same way pendingInviteCode already is (see
// joinByCode.jsx). Kept in its own key since it means something different:
// invitedByCode only ever gets used ONCE, at account creation, never at
// group-join time.
const PENDING_KEY = 'pendingReferralCode';

export function stashPendingReferral(code) {
    if (!code) return;
    try { localStorage.setItem(PENDING_KEY, code); } catch { /* private mode etc. */ }
}

// Read without removing — a failed signup must not lose the attribution, so
// callers clear it explicitly only once the request actually succeeds.
export function peekPendingReferral() {
    try { return localStorage.getItem(PENDING_KEY) || undefined; } catch { return undefined; }
}

export function clearPendingReferral() {
    try { localStorage.removeItem(PENDING_KEY); } catch { /* private mode etc. */ }
}
